<script setup lang="ts">
// PKCE 回调落点（/callback，P8 SSO 屏③无感续登连续卡）。
// account 统一登录页登录成功 → 回跳 /callback?code&state → 校验 state + 换 access token + 拉 user，
// 成功后进工作台（vault 解锁/新建由 Workspace 据云端 vault 探测决定）。
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { sdk } from '../lib/sdk'
import KeytailMascot from '../components/KeytailMascot.vue'

const route = useRoute()
const router = useRouter()

const error = ref('')
const status = ref<'pending' | 'ok' | 'fail'>('pending')
const nickname = ref('')

onMounted(async () => {
  const code = String(route.query.code || '')
  const state = String(route.query.state || '')
  const errParam = String(route.query.error || '')
  if (errParam) {
    error.value = '灵澜账号未完成授权，请重新登录。'
    status.value = 'fail'
    return
  }
  if (!code || !state) {
    error.value = '登录链接已失效或不完整，请重新登录。'
    status.value = 'fail'
    return
  }
  try {
    // exchangePKCE 校验 state（不匹配抛 'pkce: state mismatch'）后换 access + 拉 user。
    const user = await sdk.exchangePKCE(code, state)
    nickname.value = user.nickname || '灵澜用户'
    status.value = 'ok'
    // 连续卡一闪而过（约 0.7s）再放行，给「正在以你身份进入」的连续感；vault 链路在 / 继续。
    setTimeout(() => router.replace('/'), 700)
  } catch (e) {
    error.value = (e as Error)?.message || '登录未完成，请重新登录。'
    status.value = 'fail'
  }
})
</script>

<template>
  <div class="kt-identity">
    <!-- 换 token 中 -->
    <div v-if="status === 'pending'" class="kt-id-card kt-id-card--slim">
      <span class="kt-dot" /> 正在进入守狸云…
    </div>

    <!-- 成功：连续过渡卡 -->
    <div v-else-if="status === 'ok'" class="kt-id-card kt-id-card--slim">
      <div class="kt-id-brand" style="margin-bottom:8px">
        <KeytailMascot :size="48" class="kt-id-mark" />
        <div class="kt-id-word">欢迎回来，{{ nickname }}</div>
        <div class="kt-id-tag">正在以你的灵澜身份进入守狸…</div>
      </div>
    </div>

    <!-- 失败 -->
    <div v-else class="kt-id-card">
      <div class="kt-id-brand">
        <KeytailMascot :size="48" class="kt-id-mark" />
        <div class="kt-id-word">登录未完成</div>
      </div>
      <div class="kt-id-hint kt-id-hint--error">{{ error }}</div>
      <button class="kt-btn kt-btn--primary kt-id-btn" @click="router.replace('/login')">返回登录</button>
    </div>
  </div>
</template>
